import React from "react";
import "./Services.css";

const services = [
  {
    title: "Residential Construction",
    desc: "Bespoke homes that balance Rajasthani character with modern comfort.",
    tag: "Homes"
  },
  {
    title: "Commercial Projects",
    desc: "Efficient, Vastu-aligned spaces for offices, shops, and mixed-use projects.",
    tag: "Commercial"
  },
  {
    title: "Renovation & Remodeling",
    desc: "Careful upgrades and heritage-sensitive restorations for existing properties.",
    tag: "Renovation"
  },
  {
    title: "Project Management",
    desc: "End-to-end coordination, budgeting, and quality control for your build.",
    tag: "Management"
  },
  {
    title: "Construction Material Supply",
    desc: "Reliable sourcing and delivery of bricks, cement, steel, tiles, and other site essentials.",
    tag: "Material Supply"
  },
  {
    title: "Vastu Planning & Consultation",
    desc: "Site planning, room orientation, and energy flow aligned with Vastu principles.",
    tag: "Vastu Design"
  },
  {
    title: "Architectural & Interior Design",
    desc: "Concept drawings, working drawings, and interior schemes tailored to your project vision.",
    tag: "Design"
  },
  {
    title: "Labour Supply & Management",
    desc: "Skilled and unskilled labour deployment, on-site supervision, and productivity tracking for smooth project execution.",
    tag: "Labour"
  }
];

function Services() {
  return (
    <section id="services" className="services-section">
      <div className="services-header container">
        <h2 className="services-title">Our Services</h2>
        <p className="services-subtitle">
          From first sketch to final handover, Maa Bhagwati Construction manages every
          aspect of your residential and commercial projects with clarity and care.
        </p>
      </div>

      <div className="services-list container">
        {services.map((s, idx) => (
          <article className="service-card" key={idx}>
            <div className="service-icon-wrapper">
              <span className="service-icon">
                {idx === 0
                  ? "🏠"
                  : idx === 1
                  ? "🏢"
                  : idx === 2
                  ? "🛠️"
                  : idx === 3
                  ? "📋"
                  : idx === 4
                  ? "🚚"
                  : idx === 5
                  ? "🧭"
                  : idx === 6
                  ? "📐"
                  : "👷"}
              </span>
            </div>
            <div className="service-tag">{s.tag}</div>
            <h3 className="service-title">{s.title}</h3>
            <p className="service-desc">{s.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Services;
